import { render, staticRenderFns } from "./EventVenueRecommendation.vue?vue&type=template&id=d36fab06&"
import script from "./EventVenueRecommendation.vue?vue&type=script&lang=js&"
export * from "./EventVenueRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./EventVenueRecommendation.vue?vue&type=style&index=0&id=d36fab06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports